import { DataGridButton } from './DatagridButton';
import plusIcon from '../icons/plus.svg';
import deleteSweepIcon from '../icons/delete_sweep.svg';
import canceIcon from '../icons/cancel.svg';
import doneOutline from '../icons/done_outline.svg';
export class FilterCondition {
    constructor(colDef, operator, arg1, arg2) {
        this.colDef = colDef;
        if (colDef.dataType === 'boolean' || colDef.dataType === 'checkSelect') {
            this.operator = 'eq';
            this.arg1 = arg1 !== undefined ? arg1 : true;
        }
        else if (operator) {
            this.operator = operator;
        }
        else {
            // default operator based on datatype
            if (colDef.dataType === 'number' || colDef.dataType === 'date' || colDef.dataType === 'datetime') {
                this.operator = 'eq';
            }
            else {
                this.operator = 'contains'; // default for text fields
            }
        }
        this.arg1 = arg1;
        this.arg2 = arg2;
        this.apply = this.apply.bind(this);
        this.render = this.render.bind(this);
        this.harvestValue = this.harvestValue.bind(this);
        this.valToString = this.valToString.bind(this);
    }
    apply(row) {
        let val = row[this.colDef.field];
        const normalizeDateParts = (d) => {
            if (!(d instanceof Date))
                d = new Date(d);
            return {
                y: d.getFullYear(),
                m: d.getMonth() + 1,
                d: d.getDate()
            };
        };
        const normalizeDateAsTime = (d) => {
            if (!(d instanceof Date))
                d = new Date(d);
            return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
        };
        const normalize = (v) => {
            if (this.colDef.dataType === 'datetime') {
                return new Date(v).getTime();
            }
            if (this.colDef.dataType === 'number') {
                return Number(v);
            }
            if (this.colDef.dataType === 'boolean' || this.colDef.dataType === 'checkSelect') {
                if (typeof v === 'boolean')
                    return v;
                if (typeof v === 'string')
                    return v.trim().toLowerCase() === 'true';
                return Boolean(v);
            }
            if (typeof v === 'string') {
                return v.trim().toLowerCase();
            }
            return v;
        };
        const left = this.colDef.dataType === 'date' ? normalizeDateParts(val) : normalize(val);
        const right1 = this.colDef.dataType === 'date' ? normalizeDateParts(this.arg1) : normalize(this.arg1);
        const right2 = this.colDef.dataType === 'date' ? normalizeDateParts(this.arg2) : normalize(this.arg2);
        switch (this.operator) {
            case 'eq':
                if (this.colDef.dataType === 'date') {
                    return left.y === right1.y && left.m === right1.m && left.d === right1.d;
                }
                return left === right1;
            case 'ne':
                if (this.colDef.dataType === 'date') {
                    return left.y !== right1.y || left.m !== right1.m || left.d !== right1.d;
                }
                return left !== right1;
            case 'gt':
                if (this.colDef.dataType === 'date') {
                    return normalizeDateAsTime(val) > normalizeDateAsTime(this.arg1);
                }
                return left > right1;
            case 'ge':
                if (this.colDef.dataType === 'date') {
                    return normalizeDateAsTime(val) >= normalizeDateAsTime(this.arg1);
                }
                return left >= right1;
            case 'lt':
                if (this.colDef.dataType === 'date') {
                    return normalizeDateAsTime(val) < normalizeDateAsTime(this.arg1);
                }
                return left < right1;
            case 'le':
                if (this.colDef.dataType === 'date') {
                    return normalizeDateAsTime(val) <= normalizeDateAsTime(this.arg1);
                }
                return left <= right1;
            case 'between':
                if (this.colDef.dataType === 'date') {
                    const toComparable = (x) => x.y * 10000 + x.m * 100 + x.d;
                    return toComparable(left) >= toComparable(right1) && toComparable(left) <= toComparable(right2);
                }
                return left >= right1 && left <= right2;
            case 'contains': return left.includes(right1);
            case 'startsWith': return left.startsWith(right1);
            case 'endsWith': return left.endsWith(right1);
            default: return false;
        }
    }
    render() {
        const row = document.createElement('div');
        // Special handling for boolean or checkSelect
        if (this.colDef.dataType === 'boolean' || this.colDef.dataType === 'checkSelect') {
            if (this.arg1 === undefined || this.arg1 === null || this.arg1 === '') {
                this.arg1 = true;
            }
            this.operator = 'eq';
            const select = document.createElement('select');
            select.classList.add('dwc-datagrid-boolean-filter');
            const trueOption = new Option('True', 'true');
            const falseOption = new Option('False', 'false');
            if (this.arg1 === true) {
                trueOption.selected = true;
            }
            else {
                falseOption.selected = true;
            }
            select.append(trueOption, falseOption);
            select.value = this.arg1 ? 'true' : 'false';
            select.addEventListener('change', () => {
                const val = select.value;
                this.operator = 'eq';
                this.arg1 = val === 'true';
            });
            row.appendChild(select);
            return row;
        }
        row.classList.add('dwc-datagrid-filter-row');
        const operatorMap = {
            number: {
                options: ['eq', 'ne', 'gt', 'ge', 'lt', 'le', 'between'],
                labels: ['equals', 'doesn\'t equal', 'greater than', 'greater than or equal to', 'less than', 'less than or equal to', 'between']
            },
            datetime: {
                options: ['eq', 'ne', 'gt', 'ge', 'lt', 'le', 'between'],
                labels: ['equals', 'doesn\'t equal', 'greater than', 'greater than or equal to', 'less than', 'less than or equal to', 'between']
            },
            date: {
                options: ['eq', 'ne', 'gt', 'ge', 'lt', 'le', 'between'],
                labels: ['equals', 'doesn\'t equal', 'greater than', 'greater than or equal to', 'less than', 'less than or equal to', 'between']
            },
            text: {
                options: ['eq', 'ne', 'contains', 'startsWith', 'endsWith'],
                labels: ['equals', 'doesn\'t equal', 'contains', 'starts with', 'ends with']
            },
            hyperlink: {
                options: [],
                labels: []
            },
            checkSelect: {
                options: ['eq', 'ne'],
                labels: ['checked', 'unchecked']
            }
        };
        const type = this.colDef.dataType || 'text';
        const config = operatorMap[type] || operatorMap.text;
        // Prevent unsupported types from rendering filters
        if (!config.options.length) {
            const unsupported = document.createElement('span');
            unsupported.textContent = `Filtering not supported for type "${type}"`;
            row.appendChild(unsupported);
            return row;
        }
        // Operator Dropdown
        const operator = document.createElement('select');
        config.options.forEach((opt, i) => {
            const el = document.createElement('option');
            el.value = opt;
            el.textContent = config.labels[i];
            operator.appendChild(el);
        });
        operator.value = this.operator;
        row.appendChild(operator);
        // Get input type
        const getInputType = () => {
            switch (type) {
                case 'number': return 'number';
                case 'datetime': return 'datetime-local';
                case 'date': return 'date';
                default: return 'text';
            }
        };
        const inputType = getInputType();
        // Arg1 input
        const arg1 = document.createElement('input');
        arg1.type = inputType;
        arg1.value = this.arg1 ? this.valToInput(this.arg1) : '';
        arg1.required = true;
        arg1.classList.add('dwc-datagrid-filter-arg');
        row.appendChild(arg1);
        // Arg2 input (for "between")
        const arg2 = document.createElement('input');
        arg2.type = inputType;
        arg2.value = this.arg2 ? this.valToInput(this.arg2) : '';
        arg2.required = true;
        arg2.classList.add('dwc-datagrid-filter-arg2', 'hidden');
        row.appendChild(arg2);
        if (this.operator === 'between') {
            arg2.classList.remove('hidden');
        }
        // Toggle second input based on operator
        operator.addEventListener('change', (event) => {
            this.operator = event.target.value;
            if (this.operator === 'between') {
                arg2.classList.remove('hidden');
            }
            else {
                arg2.classList.add('hidden');
            }
        });
        // Inline validation
        const validateAndStore = (input, target) => {
            return () => {
                if (!input.validity.valid) {
                    input.classList.add('invalid');
                    return;
                }
                input.classList.remove('invalid');
                this[target] = this.harvestValue(input);
            };
        };
        arg1.addEventListener('input', validateAndStore(arg1, 'arg1'));
        arg2.addEventListener('input', validateAndStore(arg2, 'arg2'));
        return row;
    }
    valToInput(val) {
        switch (this.colDef.dataType) {
            case 'datetime': {
                // Convert to yyyy-MM-ddTHH:mm (datetime-local format)
                const d = new Date(val);
                return d.toISOString().slice(0, 16);
            }
            case 'date': {
                // Convert to yyyy-MM-dd
                const d = new Date(val);
                return d.toISOString().slice(0, 10);
            }
            default:
                return val.toString();
        }
    }
    valToString(val) {
        if (this.colDef.dataType === 'datetime') {
            return new Date(val).toLocaleString(this.colDef.locale);
        }
        return val.toString();
    }
    harvestValue(arg) {
        switch (this.colDef.dataType) {
            case 'number':
                return Number(arg.value);
            case 'datetime':
                return new Date(arg.value);
            case 'date':
                const [year, month, day] = arg.value.split('-').map(Number);
                return new Date(year, month - 1, day);
            default:
                return arg.value;
        }
    }
}
export class ColumnFilterModal {
    constructor(grid, onFilterChanged) {
        this.field = "";
        this.filterConditions = [];
        this.grid = grid;
        this.onFilterChanged = onFilterChanged;
        this.showModal = this.showModal.bind(this);
        this.renderFilterConditions = this.renderFilterConditions.bind(this);
        this.render = this.render.bind(this);
        this.onClickClear = this.onClickClear.bind(this);
        this.onClickAddCondition = this.onClickAddCondition.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onApplyClicked = this.onApplyClicked.bind(this);
        this.modal = null;
        this.condList = null;
    }
    showModal(field) {
        var _a, _b;
        this.field = field;
        this.filterConditions = this.grid.filterConditions[field].slice();
        if (this.condList) {
            this.renderFilterConditions();
        }
        let header = (_a = this.modal) === null || _a === void 0 ? void 0 : _a.querySelector('.dwc-datagrid-filter-header');
        if (header) {
            let colDef = this.grid.columns[field];
            header.textContent = `Filter: ${colDef.title}`;
        }
        (_b = this.modal) === null || _b === void 0 ? void 0 : _b.classList.remove('hidden');
    }
    closeModal() {
        var _a;
        (_a = this.modal) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
    }
    renderFilterConditions() {
        if (!this.condList)
            return;
        let condList = this.condList;
        condList.innerHTML = '';
        this.filterConditions.forEach(cond => {
            let row = cond.render();
            condList.appendChild(row);
        });
    }
    onClickClear(event) {
        this.filterConditions = [];
        this.renderFilterConditions();
        const normalizedField = this.field.trim().toLowerCase();
        const icon = document.querySelector(`[data-field="${normalizedField}"] .dwc-datagrid-col-filter-icon`);
        icon === null || icon === void 0 ? void 0 : icon.classList.remove('dwc-datagrid-filter-active');
    }
    onClickAddCondition(event) {
        if (!this.condList)
            return;
        const colDef = this.grid.columns[this.field];
        const cond = new FilterCondition(colDef, undefined, undefined, undefined);
        this.filterConditions.push(cond);
        const row = cond.render();
        this.condList.appendChild(row);
    }
    onApplyClicked(event) {
        this.closeModal();
        const normalizedField = this.field.trim().toLowerCase();
        const icon = document.querySelector(`[data-field="${normalizedField}"] .dwc-datagrid-col-filter-icon`);
        if (icon) {
            icon.classList.toggle('dwc-datagrid-filter-active', this.filterConditions.length > 0);
        }
        if (this.filterConditions.length === 0) {
            this.grid.clearFilter(this.field);
        }
        else {
            this.onFilterChanged(this.field, this.filterConditions);
        }
        this.grid.refresh();
    }
    render() {
        let modal = document.createElement("div");
        if (this.modal)
            return this.modal;
        this.modal = modal;
        modal.classList.add("dwc-datagrid-filter-modal");
        modal.classList.add("hidden");
        let form = document.createElement("div");
        form.classList.add("dwc-datagrid-filter-form");
        modal.appendChild(form);
        let header = document.createElement('div');
        header.classList.add('dwc-datagrid-filter-header');
        header.textContent = `Filter: `;
        form.appendChild(header);
        let condList = document.createElement('div');
        this.condList = condList;
        condList.classList.add('dwc-datagrid-filter-conditions');
        let controlsArea = document.createElement('div');
        controlsArea.classList.add('dwc-datagrid-filter-controls');
        let applyButton = new DataGridButton('Apply', doneOutline, this.onApplyClicked, 'btnCommit');
        let applyCmd = applyButton.render();
        controlsArea.appendChild(applyCmd);
        let plusButton = new DataGridButton('Add Condition', plusIcon, this.onClickAddCondition, 'btnEdit');
        let addCond = plusButton.render();
        controlsArea.appendChild(addCond);
        let clearButton = new DataGridButton('Clear', deleteSweepIcon, this.onClickClear, 'btnEdit');
        let clearCmd = clearButton.render();
        controlsArea.appendChild(clearCmd);
        let cancelButton = new DataGridButton('Cancel', canceIcon, this.closeModal, 'btnCancel');
        let cancelCmd = cancelButton.render();
        controlsArea.appendChild(cancelCmd);
        form.appendChild(condList);
        form.appendChild(controlsArea);
        modal.appendChild(form);
        return modal;
    }
}
